import { SVGProps, Ref, forwardRef } from 'react';

export const YandexGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M9.76 2.893H8.67c-1.996 0-3.046 1.011-3.046 2.502 0 1.685.726 2.475 2.216 3.487l1.232.83L5.532 15H2.889l3.176-4.73C4.238 8.96 3.212 7.687 3.212 5.536 3.212 2.841 5.092 1 8.657 1h3.54v13.987H9.758z"
            fill="#919191"
        />
    </svg>
));
YandexGrayscaleSize16Glyph.displayName = 'YandexGrayscaleSize16Glyph';
